// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__aplp8","colMin":"styles_colMin__2CCLd","colCheckbox":"styles_colCheckbox__RaD9n"};